import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import * as React from "react";
import { useGridApiContext } from "../hooks/utils/useGridApiContext.es.js";
import { GridOverlay } from "./containers/GridOverlay.es.js";
import { j as jsxRuntimeExports } from "../../../react/jsx-runtime.es.js";
const GridNoResultsOverlay = /* @__PURE__ */ React.forwardRef(function GridNoResultsOverlay2(props, ref) {
  const apiRef = useGridApiContext();
  const noResultsOverlayLabel = apiRef.current.getLocaleText("noResultsOverlayLabel");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlay, _extends({
    ref
  }, props, {
    children: noResultsOverlayLabel
  }));
});
export {
  GridNoResultsOverlay
};
//# sourceMappingURL=GridNoResultsOverlay.es.js.map
